// v2.24.1 (Finance 2026-11-03): the piece-rate week starts on the day the owner sets
// (Senin by default, Minggu–Sabtu in production). Pure helpers (no imports) for Jest.

export const NAMA_HARI = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"];
export const PILIHAN_HARI_AWAL = NAMA_HARI.map((nama, i) => [i, `${nama} – ${NAMA_HARI[(i + 6) % 7]}`]);

// "Minggu 1 Nov 2026 – Sabtu 7 Nov 2026" from the server's answer (minggu, sampai, hari_awal_nama, hari_akhir_nama)
export function labelPeriode(d, fmt = (x) => x) {
  if (!d || !d.minggu) return "";
  const awal = d.hari_awal_nama || "Senin";
  const akhir = d.hari_akhir_nama || "Minggu";
  return `${awal} ${fmt(d.minggu)} – ${akhir} ${fmt(d.sampai)}`;
}

// the first day of the week (0 Senin … 6 Minggu) as the setting stores it, from any value
export function hariAwal(v) {
  const n = parseInt(v, 10);
  return Number.isInteger(n) && n >= 0 && n <= 6 ? n : 0;
}
